declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';

@Component({
    selector: 'pickupedit',
    templateUrl: './pickupedit.modal.html',
    styleUrls: ['./pickupedit.modal.scss']
})

export class NgbPickupEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    @Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    public displayPatientdata: boolean = true;
    public displayscansdata: boolean = false;
  @Input() Eggsourcetype: string;
  //@Input() AsstSurgeon: string;
    public EggSourceType: string;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    OvumPlannedPickupDate: NgbDateStruct;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    public EggSourceActorCode: number;
    public OvulationtriggerDate: Date;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    public ActivityCodeNew: number;
    private isvisibleendo: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentUpdateIvfCycleByActivityRequest: UpdateIvfCycleByActivityRequest;
    CurrentSaveFollicularScanDetailRequest: SaveFollicularScanDetailRequest;
    CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
    CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
    CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    CurrentSaveFollicularPickupsDetailV2Request: SaveFollicularPickupsDetailV2Request;
    CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
  }
  public AsstSurgeonPickup: string;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    
    this.ShowService = false;    
      this.CurrentSaveFollicularScanDetailRequest = new SaveFollicularScanDetailRequest();

      this.CurrentSaveFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularScanOvaryDetailRequest = new SaveFollicularScanOvaryDetailRequest();
      this.CurrentSaveFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
      this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularPickupsDetailV2Request = new SaveFollicularPickupsDetailV2Request();
      this.CurrentUpdateIvfCycleByActivityRequest = new UpdateIvfCycleByActivityRequest();
      this.CurrentUpdateIvfCycleByActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularPickupsDetailV2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
      this.LoadOvariesData();
    this.LoadCycles();
    this.AsstSurgeonPickup = AppData.Instance().cas.AsstSurgeon;
    //alert(this.AsstSurgeonPickup);
      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }
    CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
    FollicularPickupEndInfo: FollicularPickUpsByCodeController;
    CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

    LoadOvariesData() {
        //alert("ScansData")
        this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularPickUpsByCodeController();
    }

    GetFollicularPickUpsByCodeController() {
        // this.StartRefreshing();
        this.spinner.show();
        this.CurrentFollicularPickUpsByCodeRequest.ConditionalOperator = 20;
        this.CurrentFollicularPickUpsByCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.CycleCode;
        //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
        //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
        //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
        //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
        //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
        //alert(this.FormattedCode);
        this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
                    this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
                    this.OvulationtriggerDate = this.FollicularPickupEndInfo.OvulationTriggerDate;
                    if (this.FollicularPickupEndInfo.OvulationTriggerDate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.OvulationTriggerDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.OvulationTriggerDate2 != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate2);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ActivityDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.ExpiryDate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ExpiryDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.ExpiryDate2 != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate2);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ExpiryDate2 = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.OvumPickupdate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPickupdate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.OvumPickupdate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.OvumPlannedPickupDate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPlannedPickupDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.OvumPlannedPickupDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }

                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    // this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    
                    //this.spinner.hide();
                    this.LoadMasterReq();
                   
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    PickupData: TreatmentCycleStatusController[];
    PickupData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.PickupData = this.ApiResData.Result;
                    var Pickuplist = this.PickupData.filter(
                        function (c) {
                            return c.PhaseActivity == "Pickup";
                        });
                    this.PickupData = Pickuplist;
                    this.PickupData2 = this.PickupData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
       //alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.FollicularPickupEndInfo.OvumPickupdate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
                    
                  this.LoadTestData();                  
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("Data")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
        this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.EggSourceActorCode = this.ActorCode;
        //alert(this.EggSourceActorCode);
      // eranki : 03 mar 2022
      var x = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate);
      if (x.length > 0) { // trigger date is not valid?? how  how?
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode,
          this.OvulationtriggerDate)[0].CycleActivityCode;

        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode,
        //this.OvulationtriggerDate)[0].CycleActivityCode;
        this.ActivityCodeNew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
          .subscribe((result) => {
            this.ApiResData = result;
            if (!this.ApiResData.hasError) {
              //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
              this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;


              this.LoadMedicineData();

            }
            else {
              this.stopRefreshing();
              if (this.ApiResData.ErrorData != "") {

                alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
              }
              else {
                alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              }
            }

          },


            (error) => {

              if (error == "401 - Unauthorized") {
                alertFunctions.AlertParamEr(error);
                this.stopRefreshing();



              }
              else {
                alertFunctions.AlertParamEr(error);
                this.stopRefreshing();
              }
            }


          );
      }
      else {
        alert("Trigger Date is not valid for this cylce? Please check.");
        this.spinner.hide();
        this.stopRefreshing();     
      }
    }
    CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
    CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

    LoadMedicineData() {
        //alert("ScansData")
        this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMedicineByCodeController();
    }

    GetIvfCycleMedicineByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.spinner.hide();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    SaveOvulationtrigger(CurrentFollicularPickupDetails: FollicularPickUpsByCodeController) {
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = CurrentFollicularPickupDetails.TriggerTime;

        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = CurrentFollicularPickupDetails.OvumPlannedPickupDate;

        //this.CurrentSaveFollicularPickupsDetailV2Request.ActualDate = CurrentFollicularPickupDetails.ActualPickupDate;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActualTime = CurrentFollicularPickupDetails.ActualPickupTime;
        //this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = CurrentFollicularPickupDetails.Surgeon;    
        this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = CurrentFollicularPickupDetails.AsstSurgeon;
        this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = CurrentFollicularPickupDetails.Anesthesiologist;
        this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = CurrentFollicularPickupDetails.SurgeonName;
        this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = CurrentFollicularPickupDetails.AsstSurgeonName;
        this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = CurrentFollicularPickupDetails.AnesthesiologistName;
        //this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = CurrentFollicularPickupDetails.AnaesthesiaType;
        this.CurrentSaveFollicularPickupsDetailV2Request.NeedleUsed = CurrentFollicularPickupDetails.NeedleUsed;
        this.CurrentSaveFollicularPickupsDetailV2Request.Route = CurrentFollicularPickupDetails.Route;
        this.CurrentSaveFollicularPickupsDetailV2Request.Complications = CurrentFollicularPickupDetails.Complications;
        this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleCount = CurrentFollicularPickupDetails.LFollicleCount;
        this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleAspirated = CurrentFollicularPickupDetails.LFollicleAspirated;
        this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleCount = CurrentFollicularPickupDetails.RFollicleCount;
        this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleAspirated = CurrentFollicularPickupDetails.RFollicleAspirated;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalLtOocytes = CurrentFollicularPickupDetails.TotalLtOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalRtOocytes = CurrentFollicularPickupDetails.TotalRtOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalOocytes = CurrentFollicularPickupDetails.TotalOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.MinPickupSize = CurrentFollicularPickupDetails.MinPickupSize;
        this.CurrentSaveFollicularPickupsDetailV2Request.Embryologist = CurrentFollicularPickupDetails.Embryologist;
        this.CurrentSaveFollicularPickupsDetailV2Request.EmbryologistName = CurrentFollicularPickupDetails.EmbryologistName;
        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;

    }
   
    onSubmit() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = new Date(this.parserFormatter.format(this.OvulationTriggerDate));
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate2 = new Date(this.parserFormatter.format(this.ActivityDate));
        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dose;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = this.FollicularPickupEndInfo.OvulationTriggerTime;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime2 = this.FollicularPickupEndInfo.OvulationTriggerTime2;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dosage;
        this.CurrentSaveFollicularPickupsDetailV2Request.Dosage2 = this.FollicularPickupEndInfo.Dosage2;
        this.CurrentSaveFollicularPickupsDetailV2Request.Batch = this.FollicularPickupEndInfo.BatchNo;
        this.CurrentSaveFollicularPickupsDetailV2Request.Batch2 = this.FollicularPickupEndInfo.BatchNo2;
        this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate = new Date(this.parserFormatter.format(this.ExpiryDate));
        this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate2 = new Date(this.parserFormatter.format(this.ExpiryDate2));
        this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType = this.FollicularPickupEndInfo.triggertype;
        if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Dual Trigger' || this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Double Trigger') {
            this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 10;
        }
        else if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Single Dose') {
            this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
        }
        //this.CurrentSaveFollicularPickupsDetailV2Request.
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode2 = AppData.Instance().UserLoginDetails.EmployeeCode;

        //this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycle = this.FollicularPickupEndInfo.PickUpTreatmentCycle;
        //this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowth = this.FollicularPickupEndInfo.FollicularGrowth;
        //this.CurrentSaveFollicularPickupsDetailV2Request.CycleActivity = this.FollicularPickupEndInfo.PickupCycleActivity;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onSubmitSchedule() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.ActualDate = new Date(this.parserFormatter.format(this.OvumPickupdate));
        this.CurrentSaveFollicularPickupsDetailV2Request.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        this.CurrentSaveFollicularPickupsDetailV2Request.PlannedDate = new Date(this.parserFormatter.format(this.OvumPlannedPickupDate));
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        //this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycle = this.FollicularPickupEndInfo.PickUpTreatmentCycle;
        //this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowth = this.FollicularPickupEndInfo.FollicularGrowth;
        //this.CurrentSaveFollicularPickupsDetailV2Request.CycleActivity = this.FollicularPickupEndInfo.PickupCycleActivity;
        this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 3;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onSubmitTeam() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = this.FollicularPickupEndInfo.Surgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
        this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = this.FollicularPickupEndInfo.AsstSurgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = this.FollicularPickupEndInfo.AsstSurgeonName;
        this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = this.FollicularPickupEndInfo.Anesthesiologist;
        this.CurrentSaveFollicularPickupsDetailV2Request.Embryologist = this.FollicularPickupEndInfo.Embryologist;
        //this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = this.FollicularPickupEndInfo.AnesthesiologistName;
        this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = this.FollicularPickupEndInfo.AnaesthesiaType;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 4;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onSubmitProcedureDetails() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.NeedleUsed = this.FollicularPickupEndInfo.NeedleUsed;
        this.CurrentSaveFollicularPickupsDetailV2Request.Route = this.FollicularPickupEndInfo.Route;
        this.CurrentSaveFollicularPickupsDetailV2Request.Complications = this.FollicularPickupEndInfo.Complications;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.AnaesthesiaType = this.FollicularPickupEndInfo.AnaesthesiaType;
        this.CurrentSaveFollicularPickupsDetailV2Request.NeedleBatchName = this.FollicularPickupEndInfo.NeedleBatchName;
        this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 5;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );

    }
    sum: number;
    TotalOocytes: number;
    onSubmitPickUpSizes() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.MinPickupSize = this.FollicularPickupEndInfo.MinPickupSize;
        this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleCount = this.FollicularPickupEndInfo.RFollicleCount;
        this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleCount = this.FollicularPickupEndInfo.LFollicleCount;
        this.CurrentSaveFollicularPickupsDetailV2Request.RFollicleAspirated = this.FollicularPickupEndInfo.RFollicleAspirated;
        this.CurrentSaveFollicularPickupsDetailV2Request.LFollicleAspirated = this.FollicularPickupEndInfo.LFollicleAspirated;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalRtOocytes = this.FollicularPickupEndInfo.TotalRtOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalLtOocytes = this.FollicularPickupEndInfo.TotalLtOocytes;
        this.TotalOocytes = this.FollicularPickupEndInfo.TotalRtOocytes + this.FollicularPickupEndInfo.TotalLtOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.TotalOocytes = this.TotalOocytes;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 6;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );
    }
        onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeAsstSurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = event;
            //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
            this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeAnaesthetist(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.Anesthesiologist = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.AnesthesiologistName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeEmbryologist(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.Embryologist = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.EmbryologistName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    ChangeRFollicle(event: any) {
        if (event != null) {
            this.FollicularPickupEndInfo.TotalRtOocytes = event;
        }
    }
    ChangeLFollicle(event: any) {
        if (event != null) {
            this.FollicularPickupEndInfo.TotalLtOocytes = event;
        }
    }
    onAssignedToActorCode2(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCode3(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode2 = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName2 = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    ProviderName: string
    SelectSurgeon() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName = receivedEntry;
            //alert(this.ProviderName);
        })
    }
    pickup() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.IsPickupConfirmed();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }

    IsPickupConfirmed() {


        console.log('..................');
        //this.StartRefreshing();
        this.CurrentUpdateIvfCycleByActivityRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentUpdateIvfCycleByActivityRequest.ActivityName = "ConfirmPickup";
        this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentUpdateIvfCycleByActivityRequest.TotalFolicularCount = this.FollicularPickupEndInfo.TotalLtOocytes + this.FollicularPickupEndInfo.TotalRtOocytes;
        this.CurrentUpdateIvfCycleByActivityRequest.ActivityDate = new Date(this.parserFormatter.format(this.OvulationTriggerDate));
        this.CurrentUpdateIvfCycleByActivityRequest.ActivityTime = this.FollicularPickupEndInfo.OvumPickupTime;
        this.CurrentUpdateIvfCycleByActivityRequest.ConditionalOperator = 10;
        this.CurrentUpdateIvfCycleByActivityRequest.DOC = this.FollicularPickupEndInfo.DOC;
        this.CurrentUpdateIvfCycleByActivityRequest.Dosage = this.FollicularPickupEndInfo.Dosage;
        this.CurrentUpdateIvfCycleByActivityRequest.MedicineCode = this.FollicularPickupEndInfo.MedicineCode;
        this.CurrentUpdateIvfCycleByActivityRequest.MedicineName = this.FollicularPickupEndInfo.MedicineName;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.UpdateIvfCycleByActivityV2(this.CurrentUpdateIvfCycleByActivityRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        // this.LoadCycles();
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    delTEST(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesTest(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesTest(l: any) {
        var item = l as IvfCycleTestByCodeController;



        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.EggSourceActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.ActorCode;

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        //this.LoadOvaryData();
                        this.LoadTestData();
                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    delMedicine(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesMedicine(l: any) {
        var item2 = l as IvfCycleMedicineByCodeController;

        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;

        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.EggSourceActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode;

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    
    AddTests() {
        const modalRef = this.modalService.open(NgbAddScanTestModal,
            {
                centered: true

          })
        modalRef.componentInstance.Typeofscreen = 'Pickup';
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;
        modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleTestByCodeController[0].ClinicalOrderItem;
        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    }
    AddMedicine() {
        const modalRef = this.modalService.open(NgbAddScanMedicineModal,
            {
                centered: true

            })
        modalRef.componentInstance.Typeofscreen = 'Pickup';
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
        modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditTest(l: IvfCycleTestByCodeController) {

        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.EggSourceActorCode, this.OvulationtriggerDate)[0].CycleActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
        this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
        this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
        this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
        this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
        this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

        const modalRef = this.modalService.open(NgbEditScanTestModal,
            {
                centered: true

            })
        modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditMedicine(l: IvfCycleMedicineByCodeController) {
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = l.CycleActivity;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
        this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
        this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
        this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
        this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
        this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;

        //this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode
        //this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;

        //this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
        //this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
        //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;
        //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";



        const modalRef = this.modalService.open(NgbEditScanMedicineModal,
            {
                centered: true

            })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
        modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
        modalRef.componentInstance.TcModelName = this.SelectedpatientDetails.TCModelName;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    BackToPatientdata() {
        this.displayPatientdata = true;
        this.displayscansdata = false;
    }
    BackTodashboard2() {
        //this.Showivf = true;
        //this.Showscan = false;
        this.router.navigate(['healins/ivfworkbench']);
    }
    printpickup() {
        //this.router.navigate(['print/pickupdetails', { PickupCodeData: this.SelectedpatientDetails.PickUpCode, Owner: this.SelectedpatientDetails.OwnerName, CycleNo: this.SelectedpatientDetails.CycleNo, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientID: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName }]);
        this.printService.printDocument("pickupdetails",
            {
                PickupCodeData: this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode, CycleCodeData: this.CycleCode, ActivityCodeData: this.ActivityCodeNew, Owner: this.SelectedpatientDetails.OwnerName, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientID: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName,
                OvulationTriggerTime: this.FollicularPickupEndInfo.OvulationTriggerTime, OvulationTriggerDate: this.FollicularPickupEndInfo.OvulationTriggerDate, MedicineName: this.FollicularPickupEndInfo.MedicineName, Dosage: this.FollicularPickupEndInfo.Dosage, SurgeonName: this.FollicularPickupEndInfo.SurgeonName, AsstSurgeonName: this.FollicularPickupEndInfo.AsstSurgeonName, AnaesthesiaType: this.FollicularPickupEndInfo.AnaesthesiaType, AnesthesiologistName: this.FollicularPickupEndInfo.AnesthesiologistName, NeedleUsed: this.FollicularPickupEndInfo.NeedleUsed,
                Route: this.FollicularPickupEndInfo.Route, Complications: this.FollicularPickupEndInfo.Complications, MinPickupSize: this.FollicularPickupEndInfo.MinPickupSize, PickupSizeUnits: this.FollicularPickupEndInfo.PickupSizeUnits, OvumPlannedPickupDate: this.FollicularPickupEndInfo.OvumPlannedPickupDate, OvumPickupdate: this.FollicularPickupEndInfo.OvumPickupdate, OvumPickupTime: this.FollicularPickupEndInfo.OvumPickupTime, RFollicleCount: this.FollicularPickupEndInfo.RFollicleCount, LFollicleCount: this.FollicularPickupEndInfo.LFollicleCount,
                ActorCodeData: this.SelectedpatientDetails.OwnerPatientRegistrationNo, FollicularGrowthCodeData: this.FollicularPickupEndInfo.FollicularGrowth, RFollicleAspirated: this.FollicularPickupEndInfo.RFollicleAspirated, LFollicleAspirated: this.FollicularPickupEndInfo.LFollicleAspirated, TotalRtOocytes: this.FollicularPickupEndInfo.TotalRtOocytes, TotalLtOocytes: this.FollicularPickupEndInfo.TotalLtOocytes, TotalOocytes: this.FollicularPickupEndInfo.TotalOocytes,
                DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
                triggertype: this.FollicularPickupEndInfo.triggertype, ExpiryDate: this.FollicularPickupEndInfo.ExpiryDate, OvulationTriggerTime2: this.FollicularPickupEndInfo.OvulationTriggerTime2, OvulationTriggerDate2: this.FollicularPickupEndInfo.OvulationTriggerDate2, MedicineName2: this.FollicularPickupEndInfo.MedicineName2, Dosage2: this.FollicularPickupEndInfo.Dosage2, ExpiryDate2: this.FollicularPickupEndInfo.ExpiryDate2,
            }

        );
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }





}
